
export async function resizeImageFromUrl(url, max_size) {
   const resizedImage = await new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = (imageEvent) => {
         // Resize the image
         const canvas = document.createElement('canvas');
         let width = image.width;
         let height = image.height;
         if (width > height) {
            if (width > max_size) {
                  height *= max_size / width;
                  width = max_size;
            }
         } else {
            if (height > max_size) {
                  width *= max_size / height;
                  height = max_size;
            }
         }
         canvas.width = width;
         canvas.height = height;
         canvas.getContext('2d').drawImage(image, 0, 0, width, height);
         const dataUrl = canvas.toDataURL('image/jpeg');
         resolve(dataUrl)
      }
      image.src = url;
   })
   return resizedImage
 }


 export async function resizeImageFromFile(file, max_size) {
   const readerResult = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (readerEvent) => {
         resolve(readerEvent.target.result)
      }
      reader.readAsDataURL(file);
   })
   return await resizeImageFromUrl(readerResult, max_size)
}

export async function getAspectRatioFromUrl(url) {
   const resizedImage = await new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = (imageEvent) => {
         // Resize the image
         let width = image.width;
         let height = image.height;
         resolve(height/width)
      }
      image.src = url;
   })
   return resizedImage
}

export async function getAspectRatioFromFile(file) {
   const readerResult = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (readerEvent) => {
         resolve(readerEvent.target.result)
      }
      reader.readAsDataURL(file);
   })
   return getAspectRatioFromUrl(readerResult)
}


export async function resizeImageFile (file, maxHeight=1920, maxWidth=1920) {
   return new Promise((resolve, reject) => {
     const reader = new FileReader();
     reader.onload = function(event) {
       const img = new Image();
       img.onload = function() {
         const canvas = document.createElement('canvas');
         let width = img.width;
         let height = img.height;

         // Resize logic
         if (width > height) {
           if (width > maxWidth) {
             height *= maxWidth / width;
             width = maxWidth;
           }
         } else {
           if (height > maxHeight) {
             width *= maxHeight / height;
             height = maxHeight;
           }
         }

         // Set canvas size and draw image
         canvas.width = width;
         canvas.height = height;
         const ctx = canvas.getContext('2d');
         ctx.drawImage(img, 0, 0, width, height);

         // Convert canvas to Blob
         canvas.toBlob((blob) => {
           resolve(blob);
         }, 'image/jpeg', 0.95);
       };
       img.src = event.target.result;
     };
     reader.readAsDataURL(file);
   });
 };